import { Grid, Paper, Typography } from "@mui/material";
import { getClientVerification } from "api/services/automation/dashboard-tan";
import { useQuery } from "react-query";
import { ResType } from "types";
import { useNavigate } from "react-router-dom";
import Loader from "components/Loader";
import { invalidPassword, validPassword } from "assets";

const TanInvalidateCheck = () => {
  const navigate = useNavigate();
  const { data, isLoading }: ResType = useQuery(["tan-invalidate-check"], getClientVerification);
  function handleClick(): void {
    navigate(`/atom-pro/income-tax-tan/invalidate`);
  }
  if (isLoading) return <Loader />;
  return (
    <Grid container spacing={1} display="flex" justifyContent="space-around">
      <Grid item xs={6}>
        <Paper
          elevation={1}
          sx={{
            width: "100%",
            // height: 90,
            backgroundColor: "#c2f0f0",
            p: 1,
          }}
          // onClick={handleClick}
        >
          <Typography variant="h6">Valid Credentials</Typography>
          <Grid container justifyContent="center" alignContent="center">
            <Grid
              item
              xs={2}
              display="flex"
              alignItems="center"
              justifyContent="center"
              textAlign="center"
            >
              <img src={validPassword} alt="aaa" height="20px" />
            </Grid>
            <Grid
              item
              xs={4}
              display="flex"
              alignItems="center"
              // justifyContent="flex-end"
              textAlign="center"
            >
              <Typography variant="h6" color="primary">
                TAN :
              </Typography>
              <Typography variant="h6" color="primary">
                {data?.data?.totalClients - data?.data?.count}
              </Typography>
            </Grid>
            <Grid
              item
              xs={2}
              display="flex"
              alignItems="center"
              justifyContent="center"
              textAlign="center"
            >
              <img src={validPassword} alt="aaa" height="20px" />
            </Grid>
            <Grid
              item
              xs={4}
              display="flex"
              alignItems="center"
              // justifyContent="flex-end"
              textAlign="center"
            >
              <Typography variant="h6" color="primary">
                Traces :
              </Typography>
              <Typography variant="h6" color="primary">
                {data?.data?.totalClientsWithTraces - data?.data?.traceCount}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>

      <Grid item xs={6}>
        <Paper
          elevation={1}
          sx={{
            width: "100%",
            // height: 90,
            backgroundColor: "#ffd1b3",
            p: 1,
            cursor: "pointer",
            "&:hover": {
              boxShadow: "0 0 0 1px red",
            },
          }}
          onClick={handleClick}
        >
          <Typography variant="h6">Invalid Credentials</Typography>
          <Grid container justifyContent="center" alignContent="center">
            <Grid
              item
              xs={2}
              display="flex"
              alignItems="center"
              justifyContent="center"
              textAlign="center"
            >
              <img src={invalidPassword} alt="aaa" height="20px" />
            </Grid>
            <Grid
              item
              xs={4}
              display="flex"
              alignItems="center"
              // justifyContent="flex-end"
              textAlign="center"
            >
              <Typography variant="h6" color="primary">
                TAN :
              </Typography>
              <Typography variant="h6" color="primary">
                {data?.data?.count}
              </Typography>
            </Grid>
            <Grid
              item
              xs={2}
              display="flex"
              alignItems="center"
              justifyContent="center"
              textAlign="center"
            >
              <img src={invalidPassword} alt="aaa" height="20px" />
            </Grid>
            <Grid
              item
              xs={4}
              display="flex"
              alignItems="center"
              // justifyContent="flex-end"
              textAlign="center"
            >
              <Typography variant="h6" color="primary">
                Traces :
              </Typography>
              <Typography variant="h6" color="primary">
                {data?.data?.traceCount}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default TanInvalidateCheck;
